import { ReactNode, useEffect } from 'react';

export const APP_SHARE_TITLE = 'Regask Backstage';

export function formatShareTitle(title: string): string {
  return title ? `${title} | ${APP_SHARE_TITLE}` : APP_SHARE_TITLE;
}

function upsertTitleMeta(
  attr: 'name' | 'property',
  key: string,
  content: string,
): void {
  let meta = document.head.querySelector<HTMLMetaElement>(
    `meta[${attr}="${key}"]`,
  );
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute(attr, key);
    document.head.appendChild(meta);
  }
  meta.content = content;
}

export function setShareTitle(title: string): void {
  const formattedTitle = formatShareTitle(title);

  document.title = formattedTitle;
  upsertTitleMeta('property', 'og:title', formattedTitle);
  upsertTitleMeta('name', 'twitter:title', formattedTitle);
}

export function useShareTitle(title: string | undefined): void {
  useEffect(() => {
    if (!title) return;
    setShareTitle(title);
  }, [title]);
}

export function PageShareTitle({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  useShareTitle(title);
  return <>{children}</>;
}
